import { useEffect } from "react";

const scrollIntoViewSetting = {
  behavior: "smooth",
  block: "end",
};

function useEnsureVisible(isItemOpen, openedId, itemWrap, parentRef) {
  useEffect(() => {
    if (
      isItemOpen &&
      itemWrap &&
      itemWrap.current &&
      parentRef &&
      parentRef.current
    ) {
      const element = itemWrap.current;
      const parentElement = parentRef.current;

      const elementRect = element.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      const isElementFullyVisible =
        elementRect.top >= parentRect.top &&
        elementRect.bottom <= parentRect.bottom &&
        elementRect.top >= 0 &&
        elementRect.bottom <=
          Math.min(
            window.innerHeight || document.documentElement.clientHeight,
            parentRect.bottom,
          );

      if (!isElementFullyVisible) {
        element.scrollIntoView(scrollIntoViewSetting);
      }
    }
  }, [isItemOpen, openedId, itemWrap, parentRef]);
}

export default useEnsureVisible;
